module.exports = __webpack_public_path__ + "static/media/all_plateforme_img.9f5b6631.png";